'use strict';

import { processInclude } from './utils/helpers';
import productQuantitySelector from './components/productQuantitySelector';
import productZoomed from './components/productZoomed';
import productDetailsList from './components/productDetailsList';
import stickyAddToCart from './components/stickyAddToCart';
import recommendationCarousel from './components/recommendationCarousel';

$(document).ready(function () {
    processInclude(require('./product/detail'));
    productQuantitySelector.init();
    productZoomed.init();
    productDetailsList.init();
    stickyAddToCart.init();
    recommendationCarousel.init();
});
